/**
 * Formats the given time into 'mm:ss'
 * @param time the time to format (in seconds)
 */
export function formatTimeMS(time: number): string {
	const hours: number = Math.floor(time / 3600)
	const minutesRemainder: number = Math.floor((time - hours * 3600) / 60)
	const seconds: number = Math.floor(time - hours * 3600 - minutesRemainder * 60)
	const minutesTotal: number = Math.floor(time / 60)

	if (isNaN(minutesTotal) || isNaN(seconds)) {
		return ''
	}

	const minutesS = (minutesTotal < 10 ? '0' : '') + minutesTotal
	const secondsS = (seconds < 10 ? '0' : '') + seconds

	return minutesS + ':' + secondsS
}

export function generateScreenVersion(): number {
	return Math.round(new Date().getTime() / 100000)
}
